import { notification } from "antd";
import { get } from "lodash";
import omitDeep from "omit-deep-lodash";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { SCREENS } from "utils/constants";
import { nextEnterpriseActive } from "../enterpriseActivity";
import View from "./View";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.COMPANY);
  const [updateUser] = useMutation(graphql.mutations.UPDATE_USER, {
    refetchQueries: [
      {
        query: graphql.queries.ORGANIZATION,
        awaitRefetchQueries: true,
        variables: { where: { id } },
      },
    ],
  });

  const { data, loading } = useQuery(graphql.queries.ORGANIZATION, {
    variables: { where: { id } },
  });

  const onBack = () => {
    navigate(SCREENS.PRIVATE.ADMIN.COMPANIES.LIST.path);
  };

  const [setEnterpriseActive] = useMutation(
    graphql.mutations.SET_ENTERPRISE_ACTIVE,
    {
      refetchQueries: [
        {
          query: graphql.queries.ORGANIZATION,
          awaitRefetchQueries: true,
          variables: { where: { id } },
        },
      ],
    },
  );

  const onToggleActive = async () => {
    try {
      const { errors } = await setEnterpriseActive({
        variables: {
          where: { id },
          data: {
            active: nextEnterpriseActive(get(data, "organization")),
          },
        },
      });
      if (errors) notification.error({ message: t("ACTIVITY.ERROR") });
    } catch (_error) {
      notification.error({ message: t("ACTIVITY.ERROR") });
    }
  };

  const onSubmit = ({ organization, user }) => {
    if (!user.id) {
      return undefined;
    }
    return updateUser({
      variables: {
        where: { id: user.id },
        data: {
          phone: user.phone,
          firstname: user.firstname,
          lastname: user.lastname,
          organization,
        },
      },
    });
  };

  if (loading) return <Loading />;

  return (
    <View
      onSubmit={onSubmit}
      onToggleActive={onToggleActive}
      enterprise={omitDeep(get(data, "organization", {}), "__typename")}
      onBack={onBack}
    />
  );
};

export default Detail;
